import axios from 'axios';

export default {
  async index() {
    const { data: { data: locations } } = await axios.get(`${window.addiesaas.config.apiUri}/customer/location`);
    return locations;
  }
}
